<template>
  <div class="flex flex-wrap inline-block justify-center">
    <!-- flex container -->
    <Vendor
      class="mt-4"
      v-for="(vendor, index) in Vendors"
      :key="index"
      :vendor="vendor"
    ></Vendor>
  </div>
</template>

<script>
import Vendor from "../components/Vendor.vue";
import db from "./firebaseinit";
export default {
  data() {
    return {
      Vendors: []
    };
  },
  components: {
    Vendor
  },
  created() {
    var self = this.Vendors;
    db.collection("vendor")
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          var el = doc.data();

          self.push(el);
        });
      });
  }
};
</script>
